import { Directive, ElementRef, Renderer2, Input, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { filter, Subscription } from 'rxjs';

@Directive({
    selector: 'button[type="submit"], [appLoadingButton]',
})
export class LoadingDirective implements OnInit, OnDestroy, AfterViewInit {
    subscriptions: Subscription = new Subscription();
    private originalText: string;
    private isLoadingActive = false;

    constructor(private el: ElementRef, private renderer: Renderer2, private loadingService: LoadingService) {}
    ngOnInit(): void {
        this.subscriptions.add(
            this.loadingService.resetDataSubject.pipe(filter((x) => x.loader)).subscribe(({ isLoading }) => {
                if (isLoading) {
                    this.showSpinner();
                } else {
                    this.hideSpinner();
                }
            })
        );
    }

    ngAfterViewInit(): void {
        this.originalText = this.el.nativeElement.innerHTML;
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private showSpinner(): void {
        this.isLoadingActive = true;
        this.renderer.setProperty(this.el.nativeElement, 'innerHTML', '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
        this.renderer.setProperty(this.el.nativeElement, 'disabled', true);
    }

    private hideSpinner(): void {
        if (!this.originalText || !this.isLoadingActive) return;
        this.isLoadingActive = false;
        this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.originalText);
        this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
    }
}
